import { deleteSelection } from 'prosemirror-commands';
import { Plugin, TextSelection } from 'prosemirror-state';
import { findParentNodeOfType, setTextSelection } from 'prosemirror-utils';

import { EditorOptions } from '@lyearn/lygo-core';

import { insertNode, isInCheckListItem, selectionType, setSelection } from '../../../utils';
import CheckListItemNodeView from './NodeView';

function plugins({ createReactNodeView }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          check_list_item(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: CheckListItemNodeView,
            });
          },
        },
      },
    }),

    new Plugin({
      props: {
        handleDOMEvents: {
          keydown: (view, event) => {
            // todo fix: selection is set before the contentDom is set to new Ref. targeting proper fix in updating RNV improvements
            const setReactSelection = (position: number) => {
              setTimeout(() => {
                view.dispatch(setTextSelection(position)(view.state.tr));
              });
            };

            if (!isInCheckListItem(view.state)) {
              return false;
            }
            const checkListItemParagraphNode = (view.state.selection as TextSelection).$from.parent;

            //if item content is empty, and user presses backspace, then delete the list item
            if (checkListItemParagraphNode?.nodeSize === 2 && event.key === 'Backspace') {
              const currentPos = view.state.selection.$from.pos;

              //set the selection to parent check_list_item and delete it
              setSelection(view, selectionType.NODE, currentPos - 2);
              deleteSelection(view.state, view.dispatch);

              //this is to prevent deleting previous node when user press backspace
              event.preventDefault();
              event.stopPropagation();

              return false;
            }

            //if item content is empty, and user presses enter, and it is last list item
            // then delete the list item and get out of checklist
            if (checkListItemParagraphNode?.nodeSize === 2 && event.key === 'Enter') {
              const listItemNode = findParentNodeOfType(view.state.schema.nodes.check_list_item)(
                view.state.selection,
              );
              const checkListNode = findParentNodeOfType(view.state.schema.nodes.check_list)(
                view.state.selection,
              );
              if (listItemNode?.node === checkListNode?.node.lastChild) {
                const currentPos = view.state.selection.$from.pos;
                //set the selection to parent check_list_item and delete it
                setSelection(view, selectionType.NODE, currentPos - 2);
                deleteSelection(view.state, view.dispatch);

                if (checkListNode?.pos !== undefined && checkListNode?.node.nodeSize) {
                  const insertPos = checkListNode?.pos + checkListNode?.node.nodeSize - 4;
                  insertNode(
                    view,
                    selectionType.NODE,
                    view.state.schema.nodes.paragraph.create(),
                    insertPos,
                  );
                  setReactSelection(insertPos + 2);
                }
                //this is to prevent deleting previous node when user press backspace
                event.preventDefault();
                event.stopPropagation();

                return false;
              }
            }

            //if user presses enter, then add a list item
            if (event.key === 'Enter') {
              const listItemNode = findParentNodeOfType(view.state.schema.nodes.check_list_item)(
                view.state.selection,
              );
              if (listItemNode?.pos && listItemNode?.node.nodeSize) {
                const insertPos = listItemNode?.pos + listItemNode?.node.nodeSize;

                insertNode(
                  view,
                  selectionType.NODE,
                  view.state.schema.nodes.check_list_item.createAndFill(),
                  insertPos,
                );
                setReactSelection(insertPos + 2);
              }
              event.preventDefault();
              event.stopPropagation();
            }

            return false;
          },
        },
      },
    }),
  ];
}

export default plugins;
